import { TwcProduct } from '../../../twc-products';

export const PRECIPITATION_PRODUCT_DATA: TwcProduct = {
  id: 'precipitation',
  defaultProductId: 'precip24hrAccum-boeing',
  productName: 'Weather-Precipitation-TWC',
  label: 'Precipitation',
  weatherType: 'PRECIP',
  description: 'TWC product (raster) - Accumulated Precipitation',
  series: 'Observation',
  timeSlicePeriodInMinutes: 15,
  lodMax: 5,
  protocol: 'WebTile',
  forecastTimeSlicePeriod: 0,
  flightLevelProductIds: {},
  zOrder: 90
};
